import { createContext, useContext } from 'react';

/**
 * Provides the WebTeams screen's locally-fetched dashboards + V2 team
 * assignments + refetch callbacks to descendants (WebTeamsViewDashboardCard →
 * WebDashboardCardMenu → useWebHomepageCard). Lets useWebHomepageCard hit the
 * feature-config API surface directly (same path launchbar/object360 use)
 * instead of going through Redux thunks.
 */
export const WebTeamsDataContext = createContext({
  dashboardsById: {},
  refetchDashboards: () => {},
  refetchTeamsV2: () => {}
});

export function useWebTeamsData() {
  return useContext(WebTeamsDataContext);
}
